import { ChevronDown } from "lucide-react";

export function TimelineConnector() {
  return (
    <div className="flex flex-col items-center py-1">
      <div className="w-0.5 h-8 bg-gray-200" />
      <ChevronDown className="size-5 text-gray-400 -mt-1" />
    </div>
  );
}
